export const imagenes = [
   
    {id:'1',name:'Bengala',src:'bengala/bengala12.png'},
    {id:'1a',name:'Bengala',src:'bengala/bengala11.png'},
    {id:'1e',name:'Bengala',src:'bengala/bengala10.png'},
    {id:'1b',name:'Bengala',src:'bengala/bengala13.png'},
    {id:'1c',name:'Bengala',src:'bengala/bengala14.png'},
    {id:'1d',name:'Bengala',src:'bengala/bengala15.png'}, 
    
  
    
    {id:'2',name:'Bombay',src:'bombay/bombay7.png'},
    {id:'2a',name:'Bombay',src:'bombay/bombay5.png'},
    {id:'2b',name:'Bombay',src:'bombay/bombay8.png'},
    {id:'2c',name:'Bombay',src:'bombay/bombay9.png'},
    {id:'2d',name:'Bombay',src:'bombay/bombay10.png'},
    {id:'2e',name:'Bombay',src:'bombay/bombay13.png'},


    {id:'3',name:'British Short Cut',src:'britishShortCut/britishShortCut1.png'},
    {id:'3a',name:'British Short Cut',src:'britishShortCut/britishShortCut2.png'},
    {id:'3b',name:'British Short Cut',src:'britishShortCut/britishShortCut3.png'},
    {id:'3c',name:'British Short Cut',src:'britishShortCut/britishShortCut4.png'},
    {id:'3d',name:'British Short Cut',src:'britishShortCut/britishShortCut5.png'},
    {id:'3e',name:'British Short Cut',src:'britishShortCut/britishShortCut6.png'},
    
    
   
    {id:'4',name:'Korat',src:'korat/korat9.png'},
    {id:'4a',name:'Korat',src:'korat/korat4.png'},
    {id:'4b',name:'Korat',src:'korat/korat5.png'},
    {id:'4c',name:'Korat',src:'korat/korat8.png'},
    {id:'4d',name:'Korat',src:'korat/korat10.png'},
    {id:'4e',name:'Korat',src:'korat/korat13.png'},
    
   
    {id:'5',name:'Ragdoll',src:'ragdoll/ragdoll1.png'},
    {id:'5a',name:'Ragdoll',src:'ragdoll/ragdoll2.png'},
    {id:'5d',name:'Ragdoll',src:'ragdoll/ragdoll5.png'},
    {id:'5e',name:'Ragdoll',src:'ragdoll/ragdoll6.png'},
    {id:'5f',name:'Ragdoll',src:'ragdoll/ragdoll7.png'},
    {id:'5g',name:'Ragdoll',src:'ragdoll/ragdoll8.png'},
    
    {id:'6',name:'Persian',src:'persian/persian1.png'},
    {id:'6a',name:'Persian',src:'persian/persian2.png'},
    {id:'6b',name:'Persian',src:'persian/persian3.jfif'},
    {id:'6d',name:'Persian',src:'persian/persian5.png'},
    {id:'6e',name:'Persian',src:'persian/persian6.png'},
    {id:'6g',name:'Persian',src:'persian/persian8.png'},


    {id:'7',name:'Scottish fold',src:'scottishFold/scottishFold5.png'},
    {id:'7b',name:'Scottish fold',src:'scottishFold/scottishFold2.png'},
    {id:'7a',name:'Scottish fold',src:'scottishFold/scottishFold1.png'},
    {id:'7c',name:'Scottish fold',src:'scottishFold/scottishFold3.jpg'},
    {id:'7d',name:'Scottish fold',src:'scottishFold/scottishFold6.png'},
    {id:'7e',name:'Scottish fold',src:'scottishFold/scottishFold4.png'},
    
    
    {id:'8',name:'Maine coon',src:'maineCoon/maineCoon22.png'},
    {id:'8a',name:'Maine coon',src:'maineCoon/maineCoon3.png'},
    {id:'8b',name:'Maine coon',src:'maineCoon/maineCoon1.png'},
    {id:'8c',name:'Maine coon',src:'maineCoon/maineCoon9.png'},
    {id:'8d',name:'Maine coon',src:'maineCoon/maineCoon10.png'},
    {id:'8h',name:'Maine coon',src:'maineCoon/maineCoon16.png'},

];

